<template>
  <!-- -->
  <div style="height: 100%">
    <list-page>
      <search-condition :show-shadow="false">
        <template #option>
          <page-button el-type="success" @click="toShowEmployeeSelect">添加</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="employeeList" height="100%" stripe border >
          <yq-table-column label="姓名" prop="employeeName"/>
        </yq-table>
      </list-table>
    </list-page>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import EmployeeSelectMulti from "@/components/h5/data/EmployeeSelectMulti.vue";

export default {
  props: {
    modelValue: {default: () => {return {employeeList: []}}},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "PE",
  components: {
    YqTableColumn,
    YqTable,
    ListPage, ListTable, SearchCondition, EmployeeSelectMulti
  },
  data() {
    return {
      employeeList: [],
    };
  },
  created() {
    this.initData();
    watch(() => this.modelValue, () => this.initData());
  },
  methods: {
    initData() {
      this.employeeList = this.modelValue.employeeList || [];
    },
    toShowEmployeeSelect() {

    }
  }
};
</script>

<style lang="scss" scoped>

</style>